// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/Notification/styles.scss
// module id = 844
// module chunks = 0